import { createRefPath } from "global/firestoreData/appData/appRefPaths";
import _ from 'lodash';
import { useContext, useMemo, useState } from "react";
import { PapsContext } from "../PapsContext";
import { useCachedData } from "./useCachedData";
import { _cacheGroupTypes } from "./useTimestamp";

const dbCallTypes = {
  notifications: 'notifications',
};

export const useNotificationsInfo = () => {

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext
  const { pathViews } = paps_state ?? {}
  const { events: eventKey } = pathViews ?? {}

  const [appScheduledNotifications, setAppScheduledNotifications] = useState()

  useCachedData({
    cache_groupType: _cacheGroupTypes.notificationInfo,
    cache_key: eventKey,
    fetchers: [
      { key: dbCallTypes.notifications, getConfigFn: getConfig_scheduledNotifications },
    ],
    updateLocalState: (data) => {
      _.forEach(data, (value, key) => {
        switch (key) {
          case dbCallTypes.notifications:
            setAppScheduledNotifications(value);
            break;
        }
      });
    }
  })

  // ------------------- Memoized stable return -------------------
  const notificationsInfo = useMemo(
    () => ({ appScheduledNotifications }),
    [appScheduledNotifications]
  );

  return notificationsInfo;

};

/**
 * clients_${pathViews.clients}_events_${pathViews.events}
 * @param {*} pathViews 
 * @param {*} callback 
 * @returns 
 */
const getConfig_scheduledNotifications = (pathViews, callback) => {
  const pathKey = `clients_${pathViews.clients}_events_${pathViews.events}`;
  return {
    refPath: createRefPath(['notificationSchedules', pathKey]),
    opts: { returnFirstObject: true, ignoreId: true, listen: true },
    callback,
  };
};